import SwitchContainer from "../../Componant/FormWidgets/Switch";

const Switch = () => {
  return (
    <div className="page-body">
      <SwitchContainer />
    </div>
  );
};

export default Switch;
